import React from 'react';
import contactData from '../data/contact.json';

function Contact() {
  const { hero, hallBookingsTitle, hallBookings, locationsTitle, fieldLabels, locations, support } = contactData;

  return (
    <div className="fade-in">
      <div className="hero">
        <h1>{hero.title}</h1>
        <p>{hero.subtitle}</p>
      </div>

      <div className="content-section container">
        <h2>{hallBookingsTitle}</h2>
        <div className="cards-container">
          {hallBookings.map((booking) => (
            <div key={booking.title} className="card">
              <h3>{booking.title}</h3>
              <p>📞 <a href={booking.href}>{booking.phone}</a></p>
            </div>
          ))}
        </div>
      </div>

      <div className="content-section container">
        <h2>{locationsTitle}</h2>

        {locations.map((location) => (
          <div key={location.title} className="contact-box">
            <h3>🏢 {location.title}</h3>
            <p><strong>{fieldLabels.address}:</strong> {location.address}</p>
            <p><strong>{fieldLabels.contactNumber}:</strong> <a href={location.phoneHref}>{location.phone}</a></p>
            <p><strong>{fieldLabels.email}:</strong> <a href={`mailto:${location.email}`}>{location.email}</a></p>
            <p>
              <strong>{fieldLabels.map}:</strong>{' '}
              <a href={location.mapHref} target="_blank" rel="noopener noreferrer">
                {location.mapLabel}
              </a>
            </p>
          </div>
        ))}
      </div>

      <div className="content-section container" style={{ textAlign: 'center' }}>
        <h2>{support.title}</h2>
        <p style={{ fontSize: '1.1rem', marginBottom: '1.5rem' }}>
          {support.text}
        </p>
        {support.links.map((link, index) => (
          <a
            key={link.href}
            href={link.href}
            className={link.className}
            style={index === 0 ? { marginRight: '1rem' } : undefined}
            target={link.external ? '_blank' : undefined}
            rel={link.external ? 'noopener noreferrer' : undefined}
          >
            {link.label}
          </a>
        ))}
      </div>
    </div>
  );
}

export default Contact;
